// -----------------------------------------------------------------
// D E V E L O P M E N T: env configuration
// -----------------------------------------------------------------
import { Environment } from "./_environment";
import moment from "moment";

const environment: Environment = {
  version: "1.0.1",
  meetersURL: "https://www.meeters.space/",
  baseURL: "https://smart-fair-staging.web.app",
  baseBackofficeURL: "https://smart-fair-staging.web.app",
  showHandledLogs: false,
  zoomApiKey: "movE-qA_TJ2O2UP_x6kwAA",
  jitsiURL: "https://meet.jit.si",
  whatsapp: {
    number: "390532900713",
    formatted: "+39 0532 900713",
  },
  assets: {
    meetersLogo: "/assets/images/logo_meeters_horizontal.png",
    logo: "/assets/images/logos/logo_remtech.png",
    footerLogos: [
      "/assets/images/logos/logo_remtech.png",
      "/assets/images/footer_sponsor_1.jpg",
      "/assets/images/footer_sponsor_2.png",
    ],
    userPlaceholder: "/assets/images/undraw/user_placeholder.svg",
    eventPlaceholder: "/assets/images/logo.png",
  },
  fairStartdate: moment("21/09/2020 12:00", "DD/MM/YYYY HH:mm"),
  fairEndDate: moment("31/12/2021 23:30", "DD/MM/YYYY HH:mm"),
  appointments: {
    duration: 30,
    startTime: "00:00",
    endTime: "00:00",
  },
  rooms: [
    "Africa",
    "Asia",
    "Oceania",
    "America",
    "Antartica",
    "Europe Room",
    "Technical Meetings",
    "International Club",
    "Plenary Room",
    "Auditorium",
  ],
  mattermost: {
    URL: "https://www.meeters.chat",
    generalRoom: "general",
    directMessagesPath: "general/messages",
  },
  firebase: {
    functionsURL: "https://us-central1-smart-fair-staging.cloudfunctions.net",
    storage: {
      buckets: {
        default: "gs://smart-fair-staging.appspot.com",
        resize: "gs://smart-fair-staging-resizable",
      },
      paths: {
        profile_images: "profile_images",
        member_images: "member_images",
        event_images: "event_images",
        stand_images: "stand_images",
      },
    },
    config: {
      apiKey: "AIzaSyAWWBA4v2zLUKEznDypBykn0BBT0VZnBdw",
      authDomain: "smart-fair-staging.firebaseapp.com",
      databaseURL: "https://smart-fair-staging.firebaseio.com",
      projectId: "smart-fair-staging",
      storageBucket: "smart-fair-staging.appspot.com",
      messagingSenderId: "661701094890",
      appId: "1:661701094890:web:af54cde7e5b11a1bd19693",
      measurementId: "G-TLTBGY12F0",
    },
  },
};

export default environment;
